import React, { useEffect, useMemo, useState } from "react";

import {
  Box,
  Checkbox,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormGroup,
  FormControlLabel,
} from "@mui/material";

import { useSnackbar } from "notistack";
import { useBlogPostActions } from "../../hooks/useBlogPostActions.jsx";
import { useNavigate } from "react-router";
import BlogPostTags from "../../pages/admin/blog/components/BlogPostTags.jsx";

export default function ReleaseNoteModal({}) {
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  const { lastestPublishedBlogPost, markAsRead } = useBlogPostActions();

  const [modalOpen, setModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [blogPost, setBlogPost] = useState(null);

  useEffect(() => {
    lastestPublishedBlogPost({
      setIsLoading,
      setResult: (res) => {
        if (res.data) {
          setBlogPost(res.data);
          setModalOpen(true);
        }
      },
    });
  }, []);

  /**
   * BlogPost öffnen
   */
  const handleOpenBlogPost = () => {
    navigate(`/blog/${blogPost.id}`);
    setModalOpen(false);
  };

  /**
   * Als gelesen markieren
   */
  const handleMarkAsRead = async () => {
    try {
      markAsRead(blogPost.id);
      setModalOpen(false);
    } catch (error) {
      console.log(error);
      enqueueSnackbar("Fehler beim Speichern", {
        variant: "error",
      });
    }
  };

  if (!blogPost) return null;

  return (
    <>
      <Dialog
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle></DialogTitle>

        <DialogContent>
          <Box mt={1}>
            <BlogPostTags blogPost={blogPost} />
            <Typography variant="caption" sx={{ mb: 3 }}>
              {blogPost.overline}
            </Typography>

            <Typography variant="h2" sx={{ mb: 3 }}>
              {blogPost.headline}
            </Typography>

            <Typography variant="body1" sx={{ mb: 3 }}>
              {blogPost.teaser}
            </Typography>
          </Box>
        </DialogContent>

        <DialogActions>
          <FormGroup>
            <FormControlLabel
              label="Als gelesen markieren"
              control={<Checkbox />}
              onChange={handleMarkAsRead}
            />
          </FormGroup>

          <Button onClick={() => setModalOpen(false)}>Schließen</Button>

          <Button variant="contained" onClick={handleOpenBlogPost}>
            Details anzeigen
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
